import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Dropdown } from 'react-bootstrap'
import { setSortAscending, setCrSortingType } from '../../actions/survey'

const mapStateToProps = ({ survey: { crSortingType, sortAscending } }) => {
  return {
    crSortingType,
    sortAscending,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetCrSortingType: (type) => {
      dispatch(setCrSortingType(type));
    },
    onSetSortAscending: (ascending) => {
      dispatch(setSortAscending(ascending));
    },
  };
};

const CrSortingWidget = ({
  useTranslate,
  sortingType,
  sortAscending,
  onSetSortAscending,
  onSetCrSortingType,
  hideImportance = false
}) => {

  const setSorting = (type, asc) => {
    onSetSortAscending(asc);
    onSetCrSortingType(type)
  }

  const getActiveText = () => {
    if (sortingType === "byResult" && !sortAscending) {
      return useTranslate('data_vault.result_descending')
    } else if (sortingType === "byResult" && sortAscending) {
      return useTranslate('data_vault.result_ascending')
    } else if (sortingType === "byRating" && !sortAscending) {
      return useTranslate('data_vault.importance_descending')
    } else if (sortingType === "byRating" && sortAscending){
      return useTranslate('data_vault.importance_ascending')
    }else if (sortingType === "byParameter"){
      return useTranslate('data_vault.parameter')
    } else {
      return useTranslate('data_vault.result_descending')
    }
  }

  return (
    <div className="sorting-container">
      <label htmlFor="selectSorting">{ useTranslate("data_vault.sort_dropdown_label") }</label>
      <div className={"dropdown-sorting"}>
        <Dropdown>
          <Dropdown.Toggle id="toggle-dropdown-sorting">
            { getActiveText() }
            <span className="ant-select-arrow" />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => setSorting("byResult", false)}
              className={`${sortingType === "byResult" && !sortAscending ? 'active' : ''}`}
            >
              { useTranslate('data_vault.result_descending') }
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => setSorting("byResult", true)}
              className={`${sortingType === "byResult" && sortAscending ? 'active' : ''}`}
            >
              { useTranslate('data_vault.result_ascending') }
            </Dropdown.Item>
            {!hideImportance &&
              <Fragment>
                <Dropdown.Item
                  onClick={() => setSorting("byRating", false)}
                  className={`${sortingType === "byRating" && !sortAscending ? 'active' : ''}`}
                >
                  { useTranslate('data_vault.importance_descending') }
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => setSorting("byRating", true)}
                  className={`${sortingType === "byRating" && sortAscending ? 'active' : ''}`}
                >
                  { useTranslate('data_vault.importance_ascending') }
                </Dropdown.Item>
              </Fragment>
            }
            <Dropdown.Item
              onClick={() => setSorting("byParameter", true)}
              className={`${sortingType === "byParameter" && sortAscending ? 'active' : ''}`}
            >
              { useTranslate('data_vault.parameter') }
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(CrSortingWidget);


// WEBPACK FOOTER //
// ./src/components/ui/sorting-widget-comparative-reports.js